import React, { useEffect, useState } from 'react'

// next components
import SearchBox from 'components/Input/SearchBox'

// resources
import PlusIcon from 'assets/icons/plus-icon-8x8.svg?component'
import MinusIcon from 'assets/icons/minus-icon-8x8.svg?component'

// custom functions
import { useViewport } from 'utils'

// styles
import styles from './index.module.scss'
import ProfileSearchBox from 'components/Input/ProfileSearchBox'

const FilterTab = props => {
  const { listingStatusList, tokenTypeList, handleListingStatus, handleSelectTokenType, handleSearch } = props
  const [showListingStatus, setShowListingStatus] = useState(false)
  const [showTokenType, setShowTokenType] = useState(false)

  return (
    <div className="w-full">
      <ProfileSearchBox onSearch={handleSearch} />
      {/* Listing Status */}
      <div className="w-full mt-[30px]">
        <div
          className="w-full flex justify-between items-start gap-[15px]"
          onClick={() => setShowListingStatus(!showListingStatus)}
        >
          <div className={`${styles.showListing}`}>Listing Status</div>
          <div className="w-[16px] h-[16px] flex items-center justify-center">
            {showListingStatus ? <MinusIcon /> : <PlusIcon />}
          </div>
        </div>

        <div className={styles.descBorder} />

        {showListingStatus && (
          <div className="mt-15px">
            {listingStatusList.map((item, index) => (
              <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                <label
                  className={`${styles.checkmark}`}
                  onClick={() => {
                    handleListingStatus(index)
                  }}
                >
                  {item.name}
                </label>
                <input
                  className={`${styles.checkbox}`}
                  type="checkbox"
                  id={item.id}
                  checked={item.checked}
                  onChange={() => {
                    handleListingStatus(index)
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      {/* Token Type */}
      <div className="w-full mt-[30px]">
        <div
          className="w-full flex justify-between items-start gap-[15px]"
          onClick={() => setShowTokenType(!showTokenType)}
        >
          <div className={`${styles.showListing}`}>Token Type</div>
          <div className="w-[16px] h-[16px] flex items-center justify-center">
            {showTokenType ? <MinusIcon /> : <PlusIcon />}
          </div>
        </div>

        <div className={styles.descBorder} />

        {showTokenType && (
          <div className="mt-15px">
            {tokenTypeList.map((item, index) => (
              <div id={`check-label-${index}`} key={index} className="flex justify-between mt-[15px]">
                <label
                  className={`${styles.checkmark}`}
                  onClick={() => {
                    handleSelectTokenType(index)
                  }}
                >
                  {item.name}
                </label>
                <input
                  className={`${styles.checkbox}`}
                  type="checkbox"
                  id={item.id}
                  checked={item.checked}
                  onChange={() => {
                    handleSelectTokenType(index)
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default FilterTab
